module.exports = __webpack_public_path__ + "static/img/shl_news_center_pictures_selected.41d0533.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shl_news_center_pictures_selected.png
// module id = 16Vx
// module chunks = 5